import React, {useState, useEffect, useRef} from 'react';
import {useParams, useNavigate} from 'react-router-dom';
import {withTranslation} from 'react-i18next';
import {Panel} from "primereact/panel";
import {Sidebar} from "primereact/sidebar";

import _FM_UnitFormComponent from "../components/_FM_unit/_FM_UnitFormComponent";
import _FM_BerthFormComponent from "../components/_FM_berth/_FM_BerthFormComponent";
import _FM_ReservationListComponent from "../components/_FM_reservation/_FM_ReservationListComponent";
import _FM_ReservationFormComponent from "../components/_FM_reservation/_FM_ReservationFormComponent";
import _FM_ReservationShowComponent from "../components/_FM_reservation/_FM_ReservationShowComponent";
import _FM_ReceiptFormComponent from "../components/_FM_receipt/_FM_ReceiptFormComponent";
import _FM_ReceiptShowComponent from "../components/_FM_receipt/_FM_ReceiptShowComponent";
import {Dialog} from "primereact/dialog";
import _FM_FolioDndComponent from "../components/_FM_folio/_FM_FolioDndComponent";
import _FM_ReservationGuestFormComponent from "../components/_FM_reservation/_FM_ReservationGuestFormComponent";
import _FM_FolioShowComponent from "../components/_FM_folio/_FM_FolioShowComponent";
import _FM_FolioFormComponent from "../components/_FM_folio/_FM_FolioFormComponent";
import _FM_ReservationRelocateFormComponent from "../components/_FM_reservation/_FM_ReservationRelocateFormComponent";
import {Message} from "primereact/message";
import HelpComponent from "../components/HelpComponent";

const _FM_AccomodatonPage = (props) => {

  const {t, i18n} = props;
  const navigate = useNavigate();
  const {id, action} = useParams();
  useEffect(() => {
    document.title = t('reservation') + ' - ' + process.env.REACT_APP_TITLE;
    window.App.help('/reservation')
  }, [action, id]);

  return (
    <div className="_FM_ReservationPage p-component p-m-lg-4">
      <HelpComponent type={"site"} position={"TOP_OF_THE_PAGE"} url={"/reservation"}/>
      <Panel>
        <_FM_ReservationListComponent/>
      </Panel>
      <Sidebar position="right" visible={(action === 'create' || action === 'update') && (!window.App.urlVars().manage)} closeOnEscape={true}
               style={{width: id ? '99%' : '780px'}}
               onHide={() => {
                 navigate('/reservation');
               }}>
        <_FM_ReservationFormComponent/>
      </Sidebar>
      <Sidebar position="right" visible={action === 'read'} closeOnEscape={true}
               style={{width: '99%'}}
               onHide={() => {
                 navigate('/reservation');
               }}>
        <_FM_ReservationShowComponent/>
      </Sidebar>
      <Sidebar position="right" visible={window.App.urlVars().manage === 'relocate'} closeOnEscape={true}
               style={{width: '99%'}}
               onHide={() => {
                 navigate(-1);
               }}>
        <_FM_ReservationRelocateFormComponent reservationId={id}/>
      </Sidebar>
      <Dialog header={t('new_receipt')} visible={window.App.urlVars().create === 'invoice' || window.App.urlVars().update === 'invoice'}
              style={{width: '99%'}}
              onHide={() => {
                navigate(-1)
              }} modal={false} draggable={false}>
        <_FM_ReceiptFormComponent />
      </Dialog>
      <Dialog header={t('new_receipt')} visible={window.App.urlVars().read === 'invoice'}
              style={{width: '99%'}}
              onHide={() => {
                navigate(-1)
              }} modal={false} draggable={false}>
        <_FM_ReceiptShowComponent />
      </Dialog>

      <Dialog visible={window.App.urlVars().read === 'folio'}
              header={t('reservation_folio')}
              footer={<React.Fragment><Message className={"w-100"} style={{background: 'transparent'}} severity="info" text={t("dialog_movable")} /></React.Fragment>}
              onHide={() => {
                navigate(-1)
              }}
              modal={false}
              style={{minWidth: '980px', width: '980px', maxWidth: '980px'}}>
        <_FM_FolioShowComponent reservationId={id} />
      </Dialog>
      <Dialog visible={window.App.urlVars().update === 'folio' || window.App.urlVars().create === 'folio'}
              header={t('reservation_folio')}
              footer={<React.Fragment><Message className={"w-100"} style={{background: 'transparent'}} severity="info" text={t("dialog_movable")} /></React.Fragment>}
              onHide={() => {
                navigate(-1)
              }}
              modal={false}
              style={{minWidth: '980px', width: '980px', maxWidth: '980px'}}>
        <_FM_FolioFormComponent reservationId={id} />
      </Dialog>
      <Dialog visible={window.App.urlVars().manage === 'folio'}
              header={t('reservation_folio')}
              onHide={() => {
                navigate('/reservation/' + action + '/' + id)
              }}
              modal={false}
              draggable={false}
              style={{width: '99%'}}>
        <_FM_FolioDndComponent />
      </Dialog>
    </div>
  )
}
export default withTranslation('common')(_FM_AccomodatonPage);
